import React, { useState } from 'react';
import { Radio } from 'antd';
import ChooseGroups from 'components/EventGroupsPicker/ChooseGroups';

const WhoSeesIt = ({ event, groupIDs, everyoneLabel, onChange }) => {
	const [limited, setLimited] = useState(groupIDs.length > 0);
	const choose = ({ target }) => {
		setLimited(target.value);
		if (!target.value) onChange([]);
	};

	return (
		<div className="ChecklistEditor-who">
			<Radio.Group value={limited} onChange={choose}>
				<Radio value={false}>{everyoneLabel}</Radio>
				<Radio value>Only some groups</Radio>
			</Radio.Group>
			{limited && <ChooseGroups event={event} groupIDs={groupIDs} handleSetGroupIDs={onChange} />}
		</div>
	);
};

export default WhoSeesIt;
